<app-base-dialog
  [visible]="visible()"
  (visibleChange)="close()"
  title="selecthorAdmin.providerList.contractDetails.title"
  testId="contract-details-dialog"
  width="600px"
  titleClass="text-lg font-semibold"
  submitLabel="common.apply"
  [submitDisabled]="applyDisabled()"
  (submitted)="apply()"
>
  <div class="flex flex-col gap-5">
    <app-model-field-percentage
      id="contract-details-commission-rate"
      label="selecthorAdmin.providerList.commissionRate"
      [(value)]="commissionRate"
      [isRequired]="true"
    />

    <app-model-field-number
      id="contract-details-partner-fee-amount"
      label="selecthorAdmin.providerList.contractDetails.partnerFeeAmount"
      [(value)]="partnerFeeAmount"
      [isRequired]="true"
      icon="pi pi-euro"
      [iconPosition]="IconPosition.End"
      [minFractionDigits]="2"
      [maxFractionDigits]="2"
    />

    <app-model-field-number
      id="contract-details-initial-contract-duration-years"
      label="selecthorAdmin.providerList.contractDetails.initialContractDurationYears"
      [(value)]="initialContractDurationYears"
      [isRequired]="true"
      mode="integer"
      [min]="1"
      [showButtons]="true"
    />

    <app-model-field-select
      id="contract-details-first-due-date"
      label="selecthorAdmin.providerList.contractDetails.firstDueDate"
      [options]="firstDueDateOptions()"
      [(value)]="directusProviderFeeFirstDueDateUuid"
      [isRequired]="true"
    />

    <app-model-field-select
      id="contract-details-recurring-due-date"
      label="selecthorAdmin.providerList.contractDetails.recurringDueDate"
      [options]="recurringDueDateOptions()"
      [(value)]="directusProviderFeeRecurringDueDateUuid"
      [isRequired]="true"
    />

    <app-model-field-text
      id="contract-details-lead-registration-url"
      label="selecthorAdmin.providerList.contractDetails.leadRegistrationUrl"
      placeholder="selecthorAdmin.providerList.contractDetails.leadRegistrationUrlPlaceholder"
      [(value)]="leadRegistrationUrl"
    />
  </div>
</app-base-dialog>
